import { Table, TimePicker, DatePicker } from "antd";
import moment from 'moment';
import DateUtil from "../../util/DateUtil";
import 'moment-timezone';
import React, { useState, useEffect } from 'react';
import SessionManager from "../../routes/SessionManager";
import LZString from 'lz-string';
import DownloadReport from "../common/DownloadReport";
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

function RainReport(props) {

    var sessionMgr = new SessionManager();
    var user = sessionMgr.readCookie('user');

    let [loading, setLoading] = useState(true);
    let [rain_recs, setRainRecs] = useState([]);
    let [date, setDate] = useState(moment());
    let [time, setTime] = useState(moment());
    let [pickedTime, setPickedTime] = useState(moment());
    let [parseCoord, setParseCoord] = useState("");
    let timezone = user.site_selected ? user.site_selected.site_iana_timezone : moment.tz.guess()
    let accumulation = 0;
    let report_columns = [
        {
            title: "Date",
            dataIndex: 'keep_it',
            key: 'keep_it',
            render: (keep_it, rec) => moment.tz(parseInt(rec.local_epoch) * 1000, timezone).format('MMM DD, YYYY')
        },
        {
            title: "Time",
            dataIndex: 'keep_it',
            key: 'keep_it',
            render: (keep_it, rec) => moment.tz(parseInt(rec.local_epoch) * 1000, timezone).format('HH:01')
        },
        {
            title: "Amount of Rain",
            dataIndex: 'keep_it',
            key: 'keep_it',
            render: (keep_it, rec) => {
                if (rec.rain === null) {
                    rec.rain = 0;
                }
                return rec.rain
            }
        },
        {
            title: "Accumulation",
            dataIndex: 'keep_it',
            key: 'keep_it',
            render: (keep_it, rec) => {
                let rain = parseFloat(rec.rain);
                accumulation = accumulation + rain;
                return <>{accumulation.toFixed(2)}</>
            }
        },
    ];

    useEffect(() => {
        fetchWeatherReport();
    }, [date, time]);

    const fetchWeatherReport = (dateFormat = date, timeFormat = time) => {
        setLoading(true);
        let start_ts = DateUtil.getDbData(timezone, dateFormat.format('YYYY-MM-DD') + ' ' + timeFormat.format('HH:59'));
        let end_date = moment(dateFormat).subtract(3, 'days').format('YYYY-MM-DD');
        let end_ts = DateUtil.getDbData(timezone, end_date);

        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            form_input: {
                "query": JSON.stringify({
                    attributes: ['local_epoch', 'json_extract(full_response, \'$.rain."1h"\') as rain', 'json_extract(full_response, \'$.coord\') as coordinates'],
                    object: 'weather_log',
                    filters: [
                        { operator: '=', attribute: 'weather', value: "Rain" },
                        { join_by: 'and', attribute: 'local_epoch', value: end_ts, operator: '>=' },
                        { join_by: 'and', attribute: 'local_epoch', value: start_ts, operator: '<=' }
                    ],
                    sort_by: [{ attribute: 'local_epoch', value: 'asc' }],
                    pagination: { page: 1, size: 100 }
                })
            }
        }

        CommonUtils.ajax(
            {
                url: API.DATA.EXPLORER,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    var prev_date = moment(date.format('YYYY-MM-DD')).subtract(1, 'days').format('YYYY-MM-DD');
                    let prevDayTS = DateUtil.getDbData(timezone, prev_date + ' ' + time.format('HH:59'));
                    if (res.data.length > 0 && res.data[res.data.length - 1].local_epoch > prevDayTS && res.data[res.data.length - 1].local_epoch < start_ts) {
                        let coord = res.data[0].coordinates;
                        setParseCoord(JSON.parse(coord));
                    } else {
                        setParseCoord("");
                    }
                    let data = [...res.data].reverse();
                    let records = [...res.data].reverse();

                    if (records.length <= 24) {
                        data = records.filter(r => r.local_epoch >= prevDayTS && r.local_epoch <= start_ts);
                    } else {
                        if (records[24].local_epoch > prevDayTS) {
                            data = records.filter(r => r.local_epoch >= prevDayTS && r.local_epoch <= start_ts);
                        }
                    }
                    data.reverse();
                    for (var d of data) {
                        d.date_format = moment.tz(parseInt(d.local_epoch) * 1000, timezone).format('YYYY-MM-DD HH');
                    }
                    //To insert '0' rain records for the Hr, if it's not available
                    let data_modified = [...data]
                    let start_ts_temp = start_ts;
                    for (var i = 0; i < 24; i++) {
                        let end_date_format = moment.tz(parseInt(start_ts_temp) * 1000, timezone).format('YYYY-MM-DD HH');

                        if (data.find(d => d.date_format === end_date_format) === undefined) {
                            data_modified.push({ 'local_epoch': start_ts_temp, 'rain': '0' });
                        }
                        start_ts_temp = start_ts_temp - 3600;
                    }

                    data_modified.sort((x, y) => x.local_epoch - y.local_epoch);
                    setLoading(false);
                    setRainRecs(data_modified);
                    setDate(date);
                    setTime(time);
                } else {
                    setLoading(false);
                    setRainRecs([]);
                    setDate(date);
                    setTime(time);
                }
            });
    }

    const onDateChange = (date) => {
        setDate(date)
    }

    const onTimeChange = (time) => {
        setTime(time);
        setPickedTime(time);
    }

    const getDownloadReportUrl = () => {
        let site_info = user.site_selected.site_name + "_" + Buffer.from(user.user_login).toString('base64') + "_" + date.format("YYYY-MM-DD") + "_" + time.format("HH:59");
        var minifiedUser = preparePDFData({ ...user });
        minifiedUser.date = date.format('YYYY-MM-DD');
        minifiedUser.time = time.format('HH:59');
        minifiedUser.is_today = minifiedUser.date && minifiedUser.date === moment().format("YYYY-MM-DD");

        minifiedUser.save_report = true;
        minifiedUser.request_id = "Rain Report - " + site_info + ".pdf";

        let url = API.getFullUrl('/pdf/rain-report/Rain Report - ' + site_info + '.pdf?' + LZString.compressToBase64(JSON.stringify(minifiedUser)) + '=payload&host=' + window.location.host);
        console.log('url', url);
        return url;
    }

    const preparePDFData = (userCopy) => {
        var pdfData = {};
        let flds = ["user_login", "user_token", "site_id"];
        for (let i = 0; i < flds.length; i++) {
            pdfData[flds[i]] = userCopy[flds[i]];
        }

        if (userCopy.site_selected) {
            pdfData.site_selected = {};
            let flds = ["site_id", "site_name", "site_iana_timezone"];
            for (let i = 0; i < flds.length; i++) {
                pdfData.site_selected[flds[i]] = userCopy.site_selected[flds[i]];
            }
        }

        return pdfData;
    };

    return (
        <React.Fragment>
            <div className="modal-header p-2 bg-primary text-white">
                <span className="modal-title">{props.title}</span>
                <div>
                    <button type='button' className='fa fa-expand' onClick={props.resizeModal}></button>
                    <button type='button' className='far fa-lg fa-times-circle pull-right' data-dismiss='modal' onClick={props.closeModal}></button>
                </div>
            </div>
            {!loading && (
                <div className="container px-2 bg-light" >
                    <div className="row p-1">
                        <div className="col-md-4 font-weight-bold text-primary pt-1 pl-4">
                            {user && user.site_selected && user.site_selected.site_name}
                        </div>
                        <div className="col-md-8 text-right">
                            <span className='mr-2'><DownloadReport report_url={getDownloadReportUrl()}></DownloadReport></span>
                            <DatePicker
                                allowClear={false}
                                inputReadOnly
                                format="YYYY-MM-DD"
                                disabledDate={(current) => {
                                    return current.isAfter(moment());
                                }}
                                defaultValue={moment(date, 'YYYY-MM-DD')}
                                showToday={false}
                                onChange={onDateChange}
                                popupStyle={{ zIndex: 10000 }}
                            />
                            <TimePicker
                                allowClear={false}
                                inputReadOnly
                                format="HH:59"
                                popupClassName="timepicker"
                                disabledTime={(current) => {
                                    return current.isAfter(moment());
                                }}
                                showNow={false}
                                onSelect={(value) => {
                                    onTimeChange(value);
                                }}
                                defaultValue={moment()}
                                value={pickedTime}
                                onChange={onTimeChange}
                                popupStyle={{ zIndex: 10000 }}
                            />
                        </div>
                    </div>
                </div>
            )}

            {!loading && parseCoord && <div className="row p-1">
                <div className="col-md-6 pt-1 " style={{ paddingLeft: "32px" }}>
                    <b>Coordinates:</b>&nbsp;
                    <span className="font-size-5">
                        <label >Latitude:</label>&nbsp;<span>{parseCoord.lat}, </span>
                    </span>
                    <span className="font-size-5">
                        <label >Longitude:</label>&nbsp;<span>{parseCoord.lon}</span>
                    </span>
                </div>
                <div className="col-md-6 pt-1" style={{ paddingLeft: "14rem" }}>
                    <span >
                        <b >Source:</b>&nbsp;
                        <span>OpenWeather</span>
                    </span>
                </div>
            </div>}

            <div className="modal-body bg-white">
                <div className="p-1">
                    <Table
                        loading={loading}
                        rowKey="local_epoch"
                        dataSource={rain_recs}
                        columns={report_columns}
                        pagination={false}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}

export default RainReport;